import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import {convertDateAndTimeToMomentObject} from 'lib/timeUtils';
import DateTimePicker from 'client/generic/DateTimePicker/DateTimePicker.react';

import {debouncedHandleInputChange} from '../../shared/utils';

const CreateAssignmentSchedulingOptions = ({errorData, startDate}) => (
  <DateTimePicker
    className='u-mar-b_2'
    customDefaultTime='06:00'
    dateError={errorData.get('start_date', null)}
    dateLabel='Start Date'
    defaultValue={startDate}
    onChange={({date, time}) => {
      const newStartDate = !date ? 'now' : convertDateAndTimeToMomentObject({date, time});
      debouncedHandleInputChange('start_date', newStartDate);
    }}
    placeholder='Assign Immediately'
    timeError={errorData.get('start_time', null)}
    timeLabel='Start Time'
  />
);

CreateAssignmentSchedulingOptions.propTypes = {
  errorData: ImmutablePropTypes.map,
  startDate: PropTypes.string
};

export default CreateAssignmentSchedulingOptions;
